import { If } from "lib/@components/switch"
import { GROUP, SCHEDULE } from "library/constants"
import { parentTreeItem } from "library/tree"
import { ScheduleGroupItem } from "./schedule-group-item"
import { ScheduleItem } from "./schedule-item"

export function ScheduleTreeItem({ item }) {
    const { $: { type } = {} } = item ?? {}
    const isRootFolder = item?.[parentTreeItem]?.id === "schedules"

    return (
        <>
            <If truthy={type === GROUP || isRootFolder}>
                <ScheduleGroupItem item={item} />
            </If>
            <If truthy={type === SCHEDULE}>
                <ScheduleItem item={item} />
            </If>
        </>
    )
}
